import Breadcrumbs from 'components/breadcrumbs';
import LoadingSpinner from 'components/loading-spinner';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import _, { isEmpty } from 'underscore';
import BluViuNutritionTabsHeader from '../../../components/bluviu-nutrition-tabs-header';
import SitesOverview from '../../../components/sites-overview';
import { useBluViuNutritionState } from '../../../context/bluviu-nutrition-context';
import { useSelectedSite } from '../../../hooks/use-selected-site';
import { CalibrationListProvider, useCalibrationListState } from '../context/calibration-list-context';
import { CalibrationListItem } from '../types/calibration-list-item.type';
import { CalibrationsParams } from '../types/calibrations-params.type';
import FilterListCalibrations from './filter-list-calibrations';
import ListCalibrations from './list-calibrations';
import { Box, Typography } from '@mui/material';

type CalibrationsContentProps = {};

const CalibrationsContent: React.FC<CalibrationsContentProps> = ({}) => {
  const [searchValue, setSearchValue] = useState<string>('');
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const [rows, setRows] = useState<CalibrationListItem[]>([]);
  const {
    calibrationsQuery: { data, isLoading },
  } = useCalibrationListState();

  useEffect(() => {
    setRows(
      _.chain(data)
        .filter((item) => (isEmpty(selectedFilters) ? true : _.contains(selectedFilters, item.state)))
        .filter((calibration) => calibration.name.toLowerCase().includes(searchValue.toLowerCase()))
        .sortBy('createdAt')
        .reverse()
        .value()
    );
  }, [data, selectedFilters, searchValue]);

  if (isLoading) return <LoadingSpinner />;
  if (!rows) return;

  return (
    <Box>
      <FilterListCalibrations
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
      />
      <ListCalibrations calibrations={rows} setCalibrations={setRows} />
    </Box>
  );
};

const CalibrationsOverview: React.FC<{}> = ({}) => {
  const { selectedSiteId } = useSelectedSite();
  const params = useParams<CalibrationsParams>();

  const {
    bluViuNutritionSitesQuery: { data: sites },
  } = useBluViuNutritionState();

  if (!selectedSiteId) {
    return <SitesOverview />;
  }

  return (
    <>
      <BluViuNutritionTabsHeader
        intro={
          <Typography color="white">
            <FormattedMessage id={`general.confidential`} />
          </Typography>
        }
        utils={
          <Breadcrumbs
            crumbs={
              selectedSiteId
                ? [
                    {
                      text: sites?.find((s) => s.globalSiteId === params.globalSiteId)?.siteName || params.globalSiteId,
                      url: ``,
                    },
                  ]
                : undefined
            }
          />
        }
      />
      <CalibrationsContent />
    </>
  );
};

const CalibrationsOverviewContainer: React.FC<{}> = () => {
  return (
    <CalibrationListProvider>
      <CalibrationsOverview />
    </CalibrationListProvider>
  );
};

export default React.memo(CalibrationsOverviewContainer);
